import axios from "axios";
import Config from "../../Config";

class VendorRequests{
  static baseUrl = `${Config.backendDomain}`;

  async getVendorPlansDetails(){
    const response = await axios.get(`${VendorRequests.baseUrl}vendor/stats/deals`,{
      headers:{
        'Authorization': `Bearer ${localStorage.getItem('dealboxx_token')}`
      }
    });
    return response.data;
  }
}
const instance = new VendorRequests();
Object.freeze(instance);

export default instance;